import {
  TextField,
  Grid,
  Typography,
  Button,
  IconButton,
  Chip,
} from "@mui/material";
import { AddCircle, RemoveCircle } from "@mui/icons-material";
import { useFormContext, Controller, useFieldArray, useWatch } from "react-hook-form";

export default function ZustaendigkeitenForm() {
  const { control, setValue, watch } = useFormContext();

  // Mitarbeiterliste mit useFieldArray verwalten
  const { fields: mitarbeiter, append, remove } = useFieldArray({
    control,
    name: "mitarbeiterListe",
  });

  const Beschriftung = ({ children }) => (
    <Typography variant="subtitle2" gutterBottom>
      {children}
    </Typography>
  );

  const felder = [
    { name: "posteingang", label: "Posteingang und Vorsortierung" },
    { name: "belegidentifikation", label: "Identifikation der Belege" },
    { name: "rechnungspruefung", label: "Prüfung der eingehenden Rechnungen" },
    { name: "digitalisierung", label: "Digitalisierung von Papierbelegen" },
    { name: "ablage", label: "Ablage der Belege" },
    { name: "aufbereitung", label: "Aufbereitung der Belege für Buchung" },
    { name: "weitergabe", label: "Weitergabe/Entgegennahme von Belegen" },
    { name: "archivierung", label: "Archivierung der Belege" },
    { name: "schutzwuerdigeBelege", label: "Bearbeitung schutzwürdiger Belege" },
    { name: "vernichtungFreigabe", label: "Freigabe zur Vernichtung von Papierbelegen" },
    { name: "vernichtungDurchfuehrung", label: "Durchführung der Vernichtung (Papierbelege)" },
    { name: "loeschungFreigabe", label: "Freigabe zur Löschung digitaler Bestände" },
    { name: "loeschungDurchfuehrung", label: "Durchführung der Löschung digitaler Bestände" }
  ];

  // Beobachte alle Zuständigkeiten auf einmal (sauber)
  const alleZustaendigkeiten = useWatch({
    control,
    name: "zustaendigkeiten",
  }) || {};

  const mitarbeiterListe = watch("mitarbeiterListe") || [];

  const handleToggle = (feldName, currentList, mitarbeiterString) => {
    const alreadyAdded = currentList.includes(mitarbeiterString);
    let updated;
    if (alreadyAdded) {
      updated = currentList.filter((i) => i !== mitarbeiterString);
    } else {
      updated = [...currentList, mitarbeiterString];
    }
    setValue(`zustaendigkeiten.${feldName}`, updated);
  };

  return (
    <Grid container spacing={4} direction="column">
      {/* Mitarbeiter hinzufügen */}
      <Grid item xs={12}>
        
      <>
      <Typography variant="h4" sx={{ fontWeight: 600, mb: 3 }}>
      Zuständigkeiten und Verantwortlichkeiten in der Belegbearbeitung
                    </Typography>


  <Typography paragraph>
    In diesem Formular werden die Zuständigkeiten und Verantwortlichkeiten der beteiligten Mitarbeiter im Rahmen der Verfahrensdokumentation festgelegt. Bitte tragen Sie die entsprechenden Informationen ein:
  </Typography>

  <Typography variant="subtitle1" gutterBottom>
    1. Mitarbeiterliste
  </Typography>
  <Typography paragraph>
    Tragen Sie alle Mitarbeiter ein, die an den unten aufgeführten Arbeitsschritten beteiligt sind. Geben Sie für jede Person den vollständigen <strong>Namen</strong> und die <strong>Personalnummer</strong> an.
  </Typography>
  <Typography paragraph>
    Nutzen Sie den Button <strong>"Mitarbeiter hinzufügen"</strong>, um weitere Personen zu ergänzen.
  </Typography>
  <Typography paragraph>
    Mit dem roten <strong>"Entfernen"-Button</strong> können Sie einen Mitarbeiter wieder aus der Liste löschen.
  </Typography>

  <Typography variant="subtitle1" gutterBottom>
    2. Zuweisung der Zuständigkeiten
  </Typography>
  <Typography paragraph>
    Für jeden Arbeitsschritt (z. B. "Posteingang und Vorsortierung", "Digitalisierung von Papierbelegen" usw.) können Sie festlegen, welche Mitarbeiter dafür zuständig sind.
  </Typography>
  <Typography paragraph>
    Jeder eingetragene Mitarbeiter wird als Auswahl-Chip angezeigt.
  </Typography>
  <Typography paragraph>
    Klicken Sie auf den Namen eines Mitarbeiters, um diesen als <strong>zuständig</strong> für den jeweiligen Schritt zu markieren (der Chip wird dann farbig hervorgehoben).
  </Typography>
  <Typography paragraph>
    Ein erneuter Klick entfernt die Zuständigkeit wieder.
  </Typography>
  <Typography paragraph>
    Es können <strong>mehrere Mitarbeiter pro Arbeitsschritt</strong> ausgewählt werden.
  </Typography>

  <Typography variant="subtitle1" gutterBottom>
    3. Zusätzliche Angaben
  </Typography>
  <Typography paragraph>
    Tragen Sie bitte folgende Informationen ein:
  </Typography>
  <ul>
    <li>
      <Typography paragraph>
        <strong>Zugriffspfad für schutzwürdige Belege:</strong> Pfad oder Speicherort der besonders schützenswerten Belege (z. B. Netzwerkpfad, Verzeichnis).
      </Typography>
    </li>
    <li>
      <Typography paragraph>
        <strong>Zugangskontroll-Verfahren:</strong> Art des verwendeten Verfahrens zum Zugriffsschutz (z. B. Benutzername/Passwort, 2-Faktor-Authentifizierung).
      </Typography>
    </li>
    <li>
      <Typography paragraph>
        <strong>Software für Passwortschutz:</strong> Name und Version der eingesetzten Software für den Passwortschutz.
      </Typography>
    </li>
  </ul>

  <Typography paragraph>
    Dieses Formular dient dazu, die Verantwortlichkeiten innerhalb der Belegbearbeitung transparent zu dokumentieren und die Schutzmaßnahmen für sensible Dokumente nachvollziehbar festzuhalten.
  </Typography>
</>

        {mitarbeiter.map((item, index) => (
          <Grid container spacing={2} key={item.id} alignItems="center" sx={{ mb: 1 }}>
            <Grid item xs={5}>
              <Controller
                name={`mitarbeiterListe.${index}.name`}
                control={control}
                render={({ field }) => (
                  <TextField {...field} label="Name" fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={5}>
              <Controller
                name={`mitarbeiterListe.${index}.personalnummer`}
                control={control}
                render={({ field }) => (
                  <TextField {...field} label="Personalnummer" fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={2}>
              <IconButton color="error" onClick={() => remove(index)}>
                <RemoveCircle />
              </IconButton>
            </Grid>
          </Grid>
        ))}
        <Button
          startIcon={<AddCircle />}
          variant="outlined"
          sx={{ mt: 2 }}
          onClick={() => append({ name: "", personalnummer: "" })}
        >
          Mitarbeiter hinzufügen
        </Button>
      </Grid>

      {/* Zuständigkeiten je Schritt */}
      {felder.map((feld, index) => {
        // Nur vollständige Mitarbeiter für die Chips anzeigen
        const vollstaendigeMitarbeiter = mitarbeiter.filter((m) => m.name && m.personalnummer);
        const currentList = alleZustaendigkeiten[feld.name] || [];
        return (
          <Grid item key={index}>
            <Beschriftung>{feld.label}</Beschriftung>
            <Grid container spacing={1}>
              {vollstaendigeMitarbeiter.map((m, i) => {
                const mitarbeiterString = `${m.name} (${m.personalnummer})`;
                const isSelected = currentList.includes(mitarbeiterString);
                return (
                  <Grid item key={i}>
                    <Chip
                      label={mitarbeiterString}
                      clickable
                      color={isSelected ? "primary" : "default"}
                      variant={isSelected ? "filled" : "outlined"}
                      onClick={() =>
                        handleToggle(feld.name, currentList, mitarbeiterString)
                      }
                    />
                  </Grid>
                );
              })}
              {vollstaendigeMitarbeiter.length === 0 && (
                <Typography variant="body2" sx={{ mt: 1, ml: 1 }}>
                  Keine Mitarbeiter vorhanden.
                </Typography>
              )}
            </Grid>
          </Grid>
        );
      })}

      {/* Weitere Felder */}
      <Grid item sx={{ mt: 4 }}>
        <Beschriftung>Zugriffspfad für schutzwürdige Belege</Beschriftung>
        <Controller
          name="schutzPfad"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Zugriffspfad" fullWidth />
          )}
        />
      </Grid>

      <Grid item>
        <Beschriftung>Zugangskontroll-Verfahren (z.B. Login-Verfahren)</Beschriftung>
        <Controller
          name="schutzZugangskontrolle"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Zugangskontroll-Verfahren" fullWidth />
          )}
        />
      </Grid>

      <Grid item>
        <Beschriftung>Software für Passwortschutz (Programmname, Version)</Beschriftung>
        <Controller
          name="schutzPasswortschutz"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Software Passwortschutz" fullWidth />
          )}
        />
      </Grid>
    </Grid>
  );
}
